import { render, staticRenderFns } from "./TravelAndTransport.vue?vue&type=template&id=2a5db334"
import script from "./TravelAndTransport.vue?vue&type=script&lang=js"
export * from "./TravelAndTransport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports